import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import SopPDFExportPublic from '@/pages/export/sop-pdf-public'

const searchSchema = z.object({
  sopId: z.string().optional(),
  token: z.string().optional(),
})

export const Route = createFileRoute('/export/sop-pdf/')({
  validateSearch: searchSchema,
  component: SopPDFExportPublic,
})

